import { RefObject } from "react";

/**
 * The HTML Element that will be collapsing/expanding when the event is triggered
 */
//collapsedContainerRef: RefObject<HTMLElement>;

/**
 * The base classname used for updating CSS styles. This will be appended with -open and -closed,
 * and the actual CSS classes should be named accordingly.
 */
//transitionClassname: string;

/**
 * Instance-specific code to run when the element is closing
 */
//closeEvent?: () => void;

/**
 * Instance-specific code to run when the element is opening
 */
//openEvent?: () => void;

/**
 * The length of the css animation, in milliseconds. Defaults to 300.
 */
// delayMs?: number

/**
 * A function to handle the timing for CSS class swaps for transitions/animations.
 */
export const handleCssTransition = (collapsedContainerRef: RefObject<HTMLElement>, transitionClassname: string, isOpening: boolean, closeEvent?: () => void, openEvent?: () => void, delayMs?: number): void => {
  if (!collapsedContainerRef.current) return;
  const openClass = `${transitionClassname}-open`;
  const closedClass = `${transitionClassname}-closed`;

  const noDelay = delayMs === 0;
  if (isOpening) {
    collapsedContainerRef.current.classList.add(closedClass);
    if (noDelay) {
      collapsedContainerRef.current.classList.remove(openClass);
      if (closeEvent) closeEvent();
    } else {
      window.requestAnimationFrame(() => {
        window.setTimeout(() => {
          collapsedContainerRef.current?.classList.remove(openClass);
          if (closeEvent) closeEvent();
        }, delayMs || 300);
      })
    }
  } else {
    collapsedContainerRef.current.classList.add(openClass);
    if (noDelay) {
      collapsedContainerRef.current.classList.remove(closedClass);
      if (openEvent) openEvent();
    } else {
      window.requestAnimationFrame(() => {
        window.setTimeout(() => {
          collapsedContainerRef.current?.classList.remove(closedClass);
          if (openEvent) openEvent();
        }, delayMs || 300);
      })
    }
  }
};
